import type { MimicSettingsSlice, MimicSettingsState, ViewerSliceCreator } from "./types";

export const mimicSettingsInitialState: MimicSettingsState = {
  mimicSettings: {},
};

export const createMimicSettingsSlice: ViewerSliceCreator<MimicSettingsSlice> = (set) => ({
  ...mimicSettingsInitialState,

  setMimicList: (settings) =>
    set((state) => {
      state.mimicSettings = {};
      for (const s of settings) {
        state.mimicSettings[s.joint_name] = {
          mimic_joint: s.mimic_joint,
          mimic_multiplier: s.mimic_multiplier,
          mimic_offset: s.mimic_offset,
        };
      }
    }),
});
